export default __webpack_public_path__ + "static/media/generic.34b747ef.png";